function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
// Copyright IBM Corp. 2020, 2020
//
// This source code is licensed under the Apache-2.0 license found in the
// LICENSE file in the root directory of this source tree.
//
export { default as uuid } from 'uuid';
import { getExtensionFromFilename, hasValidFilename, hasValidExtension } from '../../component_helpers/FileHelper';
export var FILE_UPLOAD_STATUS = {
  EDIT: 'edit',
  UPLOADING: 'uploading',
  COMPLETE: 'complete'
};
export function countFiles(files) {
  var invalid = 0;
  var uploading = 0;
  var total = 0;

  var _iterator = _createForOfIteratorHelper(files),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var fileToUpload = _step.value;
      total++;

      if (fileToUpload.invalid) {
        invalid++;
      }

      if (fileToUpload.status === FILE_UPLOAD_STATUS.UPLOADING) {
        uploading++;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var finished = total - invalid - uploading;
  return {
    invalid: invalid,
    uploading: uploading,
    total: total,
    finished: finished
  };
}
var statusScore = [FILE_UPLOAD_STATUS.COMPLETE, FILE_UPLOAD_STATUS.UPLOADING, FILE_UPLOAD_STATUS.EDIT];
export function sortFiles(a, b, numFiles) {
  var aIdx = a.index / numFiles + statusScore.indexOf(a.status);
  if (a.invalid) aIdx += statusScore.length + 1;
  var bIdx = b.index / numFiles + statusScore.indexOf(b.status);
  if (b.invalid) bIdx += statusScore.length + 1;
  return aIdx === bIdx ? 0 : aIdx < bIdx ? 1 : -1;
}
export function validateFileAdded(fileToUpload, props, getInvalidExtensionText) {
  if (fileToUpload.url && props.allowInvalidFilenameInUrl) {
    return {
      invalid: false
    };
  }

  if (fileToUpload.file.size > props.maxFileSize) {
    return {
      invalid: true,
      errorSubject: props.maxFileSizeSubject,
      errorBody: props.maxFileSizeMessage
    };
  }

  var ext = getExtensionFromFilename(fileToUpload.file.name);

  if (props.extensionRequired && !ext) {
    return {
      invalid: true,
      errorSubject: props.invalidFileText,
      errorBody: props.extensionIsRequiredText
    };
  }

  if (!hasValidFilename(fileToUpload.file.name)) {
    return {
      invalid: true,
      errorSubject: props.invalidFileText,
      errorBody: props.invalidFileNameText
    };
  }

  if (!hasValidExtension(ext, props.validExtensions)) {
    return {
      invalid: true,
      errorSubject: props.invalidFileText,
      errorBody: getInvalidExtensionText()
    };
  }

  return {
    invalid: false
  };
}